import { useEffect } from 'react';

import { Flex, Padding } from 'components/base/layout-components';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { useSelector } from 'react-redux';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import EmptyData from 'components/EmptyData';
import useAccountType from '../../hooks/useAccountType';
import useRBACPermissions from '../../hooks/useRBACPermissions';
import { LBButton } from '@linearb/buzz';

const Wrapper = styled(Flex)`
  background-color: ${getColor('catskillWhite')};
  text-align: center;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const PulseRetroEmptyState = ({ selectedIteration = {}, projectUuid } = {}) => {
  const history = useHistory();

  const selectedTeam = useSelector(selectedTeamSelector);
  const { isUserViewer } = useAccountType();
  const { isPermitted } = useRBACPermissions();
  // TO DO: when isRBACEnabled is true in GA - remove : !isUserViewer
  const showGoToSettings = isPermitted && !isUserViewer;

  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.PULSE,
      click_type: TRACKING.EVENTS.VISIT,
      iteration_id: selectedIteration?.provider_id || selectedIteration?.id,
      selected_team_name: selectedTeam?.name,
      selected_team_id: selectedTeam?.id,
      project_uuid: projectUuid
    });
  }, []);
  const goToSettings = () => {
    history.push(AppRouter.PROJECT_MANAGEMENT.path);
  };

  return (
    <Wrapper>
      <EmptyData
        title={'No activity found'}
        info={
          'No data was found for this iteration. There may be a misconfiguration issue'
        }
        pb='medium'
        pt={'no-space'}
      />
      {showGoToSettings && (
        <Padding padding='small'>
          <LBButton onClick={goToSettings}>Check Team Settings</LBButton>
        </Padding>
      )}
    </Wrapper>
  );
};

export default PulseRetroEmptyState;
